// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var EnrollPatientCaseSource;
(function (EnrollPatientCaseSource) {
    EnrollPatientCaseSource["patientportal"] = "patientportal";
    EnrollPatientCaseSource["providerportal"] = "providerportal";
})(EnrollPatientCaseSource || (EnrollPatientCaseSource = {}));
//# sourceMappingURL=enrollPatientCaseSource.js.map